import Adicionar from './Adicionar';
import Default from './Default';
import Editar from './Editar';

const PlanosDefault = Default;

export default PlanosDefault;
export const PlanosAdicionar = Adicionar;
export const PlanosEditar = Editar;
